import { render } from "./component-egrul-date-search-loc-reestr.vue?vue&type=template&id=11de6ba8"
import script from "./component-egrul-date-search-loc-reestr.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-date-search-loc-reestr.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-date-search-loc-reestr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11de6ba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11de6ba8', __exports__)) {
    api.reload('11de6ba8', __exports__)
  }
  
  module.hot.accept("./component-egrul-date-search-loc-reestr.vue?vue&type=template&id=11de6ba8", () => {
    api.rerender('11de6ba8', render)
  })

}


export default __exports__